// store/slices/instantServicesListSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  services: [],
  isLoading: false,
  error: null,
};

const instantServicesListSlice = createSlice({
  name: "instantServicesList",
  initialState,
  reducers: {
    fetchServicesRequest: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchServicesSuccess: (state, action) => {
      state.isLoading = false;
      state.services = action.payload;
      state.error = null;
    },
    fetchServicesFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    clearServices: (state) => {
      state.services = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  fetchServicesRequest,
  fetchServicesSuccess,
  fetchServicesFailure,
  clearServices,
} = instantServicesListSlice.actions;

export default instantServicesListSlice.reducer;
